import { combineReducers } from 'redux';
import theme from './theme';

export default combineReducers({
    theme
});